
import firebase from 'firebase/app'
import 'firebase/auth'

const config = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID
}

export const initializeFirebase = () => {
  firebase.initializeApp(config)
}



// WEBPACK FOOTER //
// ./src/js/authentication/firebaseConfig.js